<template>
  <b-list-group-item :variant="is_squared ? 'success' : ''">
    <b-row>
      <b-col sm="2" md="2" xl="2">
        <p class="font-lg font-weight-bold"># {{ lot }}</p>
      </b-col>
      <b-col class="" sm="2" md="2" xl="2">
        KG VOLTEADOS <br />
        <span class="font-lg font-weight-bold">
          {{ net_kilograms_sum_in }}
        </span>
      </b-col>
      <b-col sm="2" md="2" xl="2">
        <p>
          KG PROCESADOS <br />
          <span class="font-lg font-weight-bold">
            {{ net_kilograms_sum_out }}
          </span>
        </p>
      </b-col>
      <b-col sm="2" md="2" xl="2">
        <p>
          KG RESTANTES <br />
          <span class="font-lg font-weight-bold">
            {{ (net_kilograms_sum_in - net_kilograms_sum_out).toFixed(2) }}
          </span>
        </p>
      </b-col>
      <b-col sm="4" md="4" xl="4" class="text-right">
        <create-content-buttons
          v-if="!is_squared"
          :lot="lot"
          :lot_id="lot_id"
          :product_id="product_id"
          :net_kilograms_sum_in="net_kilograms_sum_in"
          :net_kilograms_sum_out="net_kilograms_sum_out"
        ></create-content-buttons>
        <span v-if="is_squared" class="font-weight-bold">LOTE CUADRADO</span>
      </b-col>
    </b-row>
    <span> </span>
  </b-list-group-item>
</template>

<script>
import CreateContentButtons from "./CreateContentButtons";

import numeral from "numeral";
import _ from "lodash";

export default {
  name: "Lot",
  components: {
    CreateContentButtons
  },
  props: {
    lot: {
      type: String,
      default: ""
    },
    net_kilograms_sum_in: {
      type: String,
      default: 0
    },
    net_kilograms_sum_out: {
      type: String,
      default: 0
    },
    lot_id: {
      type: Number,
      default: 0
    },
    product_id: {
      type: Number,
      default: 0
    },
    product_name: {
      type: String,
      default: 0
    }
  },
  computed: {
    is_squared() {
      return this.net_kilograms_sum_in - this.net_kilograms_sum_out <= 0;
    },
    productSetIsEmpty() {
      // return !_.isEmpty(this.product_set);
    }
  },
  methods: {
    difference(a, b) {
      return numeral(a).difference(b);
    }
  }
};
</script>

<style scoped></style>
